<template>
  <component :is="component" />
</template>

<script>
import MajorShareholdersHk from './MajorShareholdersHk.vue'
import MajorShareholdersUs from './MajorShareholdersUs.vue'
import MajorShareholdersHs from './MajorShareholdersHs.vue'

const components = {
  hk: MajorShareholdersHk,
  hs: MajorShareholdersHs,
  us: MajorShareholdersUs
}
export default {
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    component() {
      return components[this.market]
    }
  }
}
</script>
